import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "chat-tabs" }
const _hoisted_4 = { class: "user-count" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Giveaway = _resolveComponent("Giveaway")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_GlobalChat = _resolveComponent("GlobalChat")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#chat-container" }, [
    _createElementVNode("div", {
      class: "chat-panel",
      style: _normalizeStyle({ display: _ctx.isOpen ? 'flex' : 'none' })
    }, [
      (_ctx.hasGiveawaysBanner && !_ctx.isActiveTabSystem)
        ? (_openBlock(), _createBlock(_component_Slider, {
            key: 0,
            autoplay: 3000,
            items: _ctx.chatGiveaways,
            "item-key-prop": "id"
          }, {
            slide: _withCtx(({ item }) => [
              _createVNode(_component_Giveaway, { giveaway: item }, null, 8, ["giveaway"])
            ]),
            _: 1
          }, 8, ["items"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Tabs, {
              onChange: _ctx.changeTab,
              tabs: _ctx.chatTabs
            }, null, 8, ["onChange", "tabs"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_UserIcon),
              _createTextVNode(" " + _toDisplayString(_ctx.globalConfig.data.onlineUsersCount?.toLocaleString()), 1)
            ]),
            _createElementVNode("div", {
              class: "arrow",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createVNode(_component_Arrow, { style: {"transform":"rotate(90deg)"} })
            ])
          ])
        ])
      ]),
      (_ctx.activeTab == 'global')
        ? (_openBlock(), _createBlock(_component_GlobalChat, {
            key: 1,
            "is-open": _ctx.isOpen
          }, null, 8, ["is-open"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        id: `tawk_${_ctx.TAWK_ID}`
      }, null, 8, _hoisted_6), [
        [_vShow, _ctx.activeTab == 'system']
      ])
    ], 4)
  ]))
}